import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { get, isEmpty } from "lodash";
import {
  ManagePlanLayout,
  AddPlans,
  CsplTable as Table,
  LoaderWrapper,
  AddToolTip,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  OPTIONS_DATA_MAPPER,
  getNullTableItem,
  getAdvancedPathWithParam,
} from "../../../utils";
import { listSource, listSponsor } from "../../../services";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import {
  clearLocalCacheByModel,
  createPlanStore,
  setManagePlanFlow,
  setManagePlanLocalCache,
} from "../../../contexts";
import { useState } from "react";

const columns = [
  {
    label: "Source Name",
    className: "column-source-name",
    columnName: "sourceName",
    link: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
  },
  {
    label: "Source Catergory",
    className: "column-source-catergory",
    columnName: "sourceCategory",
    dataMapper: OPTIONS_DATA_MAPPER.SOURCE_CATEGORY_TYPES,
  },
  // {
  //   label: "Status",
  //   className: "column-source-status",
  //   columnName: "status",
  //   dataMapper: OPTIONS_DATA_MAPPER.SOURCES_ADDED_TOPLAN,
  // },
];

const ManageSourcesContainer = (props) => {
  const { flow, planId } = useRouterParams();
  const { state, dispatch } = useContext(createPlanStore);
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([]);

  useDeepEffect(() => {
    dispatch(clearLocalCacheByModel("sources"));
    dispatch(clearLocalCacheByModel("listSource"));
    setLoad(true);
    listSource(parseInt(planId))
      .then((res) => {
        setLoad(false);
        setData(res);
      })
      .catch((ex) => {
        setLoad(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // useEffect(() => {
  //   if (planId) {
  //     listSource(parseInt(planId)).then((res) =>
  //       get(res, "message.isSuccessfull", false)
  //         ? dispatch(
  //             setManagePlanFlow({
  //               sources: get(res, "message.employerSourcesList", []),
  //             })
  //           )
  //         : null
  //     );
  //   }
  // }, []);
  const sourcesData = get(data, "employerSourcesList", []);
  const onAddClick = () => {
    const { history } = props;

    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
        pathParam: [FLOW_TYPES.ADD, planId, 0],
      })
    );
  };

  const buttons = [
    {
      label: "Add",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onAddClick,
    },
    // {
    //   label: "New Source",
    //   type: "button",
    //   flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
    //   onClick: onAddClick,
    //   isAddButton: true,
    // },
  ];
  const noOfSources = sourcesData.length ? `${sourcesData.length} Sources` : "";
  return (
    <LoaderWrapper isLoading={load}>
      <ManagePlanLayout buttons={buttons} pageFlow={flow}>
        {isEmpty(sourcesData) && (
          <AddPlans
            menu="plan"
            subMenu="sources"
            content="No sources have been setup for this plan"
            buttonLabel="Create A New Source"
            // secondaryButtonLabel="Add Sources From Master"
            // secondaryButtonLink={getPathWithParam({
            //   path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_MASTER,
            //   pathParam: [planId],
            // })}
            link={getPathWithParam({
              path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
              pathParam: [FLOW_TYPES.ADD, planId, 0],
            })}
          />
        )}
        {!isEmpty(sourcesData) && (
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading">Manage Sources</div>
              <div>{noOfSources}</div>
            </div>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columns.map((item, index) => {
                    return (
                      <Table.Th key={index} className={item.className}>
                        {item.label}
                      </Table.Th>
                    );
                  })}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {sourcesData.map((source, index) => {
                  return (
                    <Table.Tr key={index}>
                      {columns.map((item, cellIndex) => {
                        return (
                          <Table.Td key={cellIndex} className={item.className}>
                            {getNullTableItem(
                              !isEmpty(item.link) ? (
                                <AddToolTip name={source[item.columnName]}>
                                  <Link
                                    to={getPathWithParam({
                                      path: item.link,
                                      pathParam: [
                                        FLOW_TYPES.EDIT,
                                        planId,
                                        source.id,
                                      ],
                                    })}
                                  >
                                    {source[item.columnName]}
                                  </Link>
                                </AddToolTip>
                              ) : item.dataMapper ? (
                                item.dataMapper[source[item.columnName]]
                              ) : (
                                source[item.columnName]
                              )
                            )}
                          </Table.Td>
                        );
                      })}
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </div>
        )}
      </ManagePlanLayout>
    </LoaderWrapper>
  );
};

export default ManageSourcesContainer;
